import { lazy } from "react";

// route
export const rkaRoute = { path: "/rka", name: "menu.rka", icon: "balance" };
export const rkaPlanningRoute = { path: `${rkaRoute.path}/planning`, name: "rka_planning." };
export const rkaPlanningDetailRoute = { path: `${rkaPlanningRoute.path}/detail`, name: "rka_planning.detail" };
export const rkaPlanningCreateRoute = { path: `${rkaPlanningRoute.path}/create`, name: "rka_planning.add" };
export const rkaPlanningEditRoute = { path: `${rkaPlanningRoute.path}/edit`, name: "rka_planning.edit" };

// component
const RKA = lazy(() => import("../page/rka/RKA"));
const RKAPlanning = lazy(() => import("../page/rka/planning/RKAPlanning"));
const RKAPlanningForm = lazy(() => import("../page/rka/planning/form/RKAPlanningForm"));
const RKAPlanningView = lazy(() => import("../page/rka/planning/view/RKAPlanningView"));

export const RKAListRoutes = [
    rkaPlanningRoute
]

export const RKAMutationRoute = [
    rkaPlanningRoute, rkaPlanningCreateRoute, rkaPlanningEditRoute, rkaPlanningDetailRoute
]

export const rkaRoutes = {
    element: <RKA />,
    children: [
        { ...rkaPlanningRoute, element: <RKAPlanning /> },
        { ...rkaPlanningCreateRoute, element: <RKAPlanningForm /> },
        { ...rkaPlanningEditRoute, element: <RKAPlanningForm /> },
        { ...rkaPlanningDetailRoute, element: <RKAPlanningView /> },
    ],
};